module.exports = __webpack_public_path__ + "img/full2-min.b6cc935e.png";